import type { PropsWithChildren } from "react"

import { AppContent } from "@/components/app-content"
import { AppShell } from "@/components/app-shell"
import { AppSidebarHeader } from "@/components/app-sidebar-header"
import {
  AnnouncementDock,
  AnnouncementsProvider,
} from "@/components/member/announcement-stories"
import { InstallAppLinks } from "@/components/member/install-app-links"
import { MemberSidebar } from "@/components/member-sidebar"
import type { BreadcrumbItem } from "@/types"

export default function MemberSidebarLayout({
  children,
  breadcrumbs = [],
}: PropsWithChildren<{
  breadcrumbs?: BreadcrumbItem[]
}>) {
  return (
    <AnnouncementsProvider>
      <AppShell variant="sidebar">
        <MemberSidebar />
        <AppContent variant="sidebar" className="overflow-x-hidden">
          <AppSidebarHeader
            breadcrumbs={breadcrumbs}
            actions={<InstallAppLinks />}
          />
          {children}
        </AppContent>
        <AnnouncementDock />
      </AppShell>
    </AnnouncementsProvider>
  )
}
